import i18n from '@/plugins/i18n';
import { Company } from './companiesModels';

export function toCompanyAutocompleteItem(company: Company) {
    const title =
        company.companyNumber === '0' ? i18n.global.t('shared.resources.common.all') : `${company.name} (${company.companyNumber})`;
    return { title: title === '' ? company.name : title, value: company.id.toString(), data: company };
}
